export const recipeDtoFields = [{
        name: "description",
        title: "Descrizione",
        render: (record) => record.recipe.description
    }, {
        name: "productTypeName",
        title: "Tipo Prodotto",
        render: (record) => record.productTypeName
    }, {
        name: "active",
        title: "Attiva",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.recipe.active === 1 ? "check" : ""}</i>`
    }];
